/**
 * Pack builder: pack tabs, shade slots, sheet/modal, sticky ATC nudge.
 * Complete Look: open side cart drawer after product-card ATC.
 *
 * PRICE / CHECKOUT (mirrors Liquid comments in pdp-upsell-pack-builder.liquid)
 * ---------------------------------------------------------------------------
 * Pack card data attrs (from product_upsell metaobject):
 *   data-pack-price      → payable on ATC (coupon% / fixed / unit×qty)
 *   data-pack-mrp        → strikethrough base
 *   data-pack-save       → pack_mrp − pack_price (card banner only)
 *   data-pack-coupon     → if set, fetch /discount/{code} then GoKwik (not native redirect)
 *   data-pack-coupon-pct → % used for UI payable when coupon set
 *   data-pack-discounted → raw discounted_price cents (0 = unset)
 *
 * ATC button shows: "Buy Now - ₹{pack_price}" on shade-packs;
 * complete-look uses "Add to cart - ₹{pack_price}".
 * Save stays on pack cards.
 *
 * Add to cart flow (Helium-shaped payload):
 *   1) clear cart
 *   2) cart/add.js with items + attributes in one request:
 *        properties: {
 *          _h_bundle_count: <pack qty>,
 *          _bundle_target_price: <selected pack price>,
 *          _is_bundle_item: 'true'
 *        }
 *        attributes: { Bundle_Name: 'heliumbyob' + <pack payable rupees> }
 *        // TODO: check upsell tags — previously tried Bundle_Name = 'upsell pack of <qty>'
 *        //       (cart attribute ≠ order tag; needs Shopify Flow / Helium bundle names)
 *   3) always clear prior discount session, then if selected pack has
 *      discount_coupon → apply that latest code via /discount/{code}, then GoKwik
 *   4) else (no coupon on this pack) → GoKwik / native with no leftover code
 */
(function () {
  'use strict';

  function moneyFromCents(cents, currency) {
    var value = (Number(cents) || 0) / 100;
    var formatted = value % 1 === 0 ? String(Math.round(value)) : value.toFixed(2);
    return (currency || '₹') + formatted;
  }

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function centsToRupees(cents) {
    return Math.round(((Number(cents) || 0) / 100) * 100) / 100;
  }

  function packNameFromSize(size) {
    return 'pack_of_' + (Number(size) || 1);
  }

  function pushUpsellEvent(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    var data = { event: eventName };
    if (payload) {
      Object.keys(payload).forEach(function (key) {
        data[key] = payload[key];
      });
    }
    window.dataLayer.push(data);
  }

  function selectedShadeRows(state) {
    return (state.selections || []).filter(Boolean);
  }

  function getPackAnalytics(root, state) {
    var productId = String((root && root.dataset.productId) || '');
    var itemId = String((root && root.dataset.itemId) || '');
    var itemName = String((root && root.dataset.itemName) || '');
    var packSize = Number(state.packQty) || 1;
    var price = centsToRupees(state.packPrice);
    var selected = selectedShadeRows(state);
    var productIds = selected
      .map(function (sel) {
        return String(sel.productId || '');
      })
      .filter(Boolean);
    var ecommIds = productIds.slice();
    if (!ecommIds.length && itemId) ecommIds = [itemId];
    if (!productIds.length && productId) productIds = [productId];
    if (!ecommIds.length && productId) ecommIds = [productId];
    return {
      pack_size: packSize,
      pack_name: packNameFromSize(packSize),
      product_id: productId,
      product_ids: productIds,
      price: price,
      item_id: itemId || ecommIds[0] || productId,
      item_name: itemName,
      ecomm_prodid: ecommIds.length === 1 ? ecommIds[0] : ecommIds,
      ecomm_totalvalue: price,
      value: price
    };
  }

  function findStickyAtcBar() {
    var mobile = document.querySelector('.pdp-revamp__atc-sticky');
    if (mobile && window.getComputedStyle(mobile).position === 'fixed') return mobile;
    return (
      document.querySelector('.m_sticky_addToCart.pdp-sticky-atc--revamp.is-shown') ||
      document.querySelector('.m_sticky_addToCart.pdp-sticky-atc--revamp')
    );
  }

  function placeUpsellNudge(nudgeEl) {
    if (!nudgeEl || nudgeEl.hidden) return;
    var bar = findStickyAtcBar();
    var isDesktop = window.innerWidth >= 768;
    var gap = isDesktop ? 12 : 0;
    var fallback = isDesktop ? 84 + gap : 79 + gap;
    var bottom = fallback;
    if (bar) {
      var rect = bar.getBoundingClientRect();
      if (rect.height > 0) {
        bottom = Math.max(gap, Math.round(window.innerHeight - rect.top + gap));
      }
    }
    nudgeEl.style.bottom = bottom + 'px';
  }

  function portalNudge(nudgeEl) {
    if (nudgeEl && nudgeEl.parentNode !== document.body) {
      document.body.appendChild(nudgeEl);
    }
  }

  function initPackBuilder(root) {
    if (!root || root.dataset.packReady === 'true') return;
    root.dataset.packReady = 'true';

    var unitPrice = Number(root.dataset.unitPrice || 0);
    var currency = root.dataset.currency || '₹';
    var nudgeEmpty = root.dataset.nudgeEmpty || 'Add shades to unlock the deal';
    var nudgeMore = root.dataset.nudgeMore || 'Add {n} more shade(s) to unlock the deal';
    var nudgeComplete = root.dataset.nudgeComplete || 'Pack complete';

    var slotsEl = root.querySelector('[data-shade-slots]');
    var nudgeEl = root.querySelector('[data-pack-nudge]');
    var nudgeFillEl = nudgeEl ? nudgeEl.querySelector('[data-nudge-fill]') : null;
    var nudgeTextEl = nudgeEl ? nudgeEl.querySelector('[data-nudge-text]') : null;
    var sheet = root.querySelector('[data-shade-sheet]');
    var sheetTitle = root.querySelector('[data-shade-sheet-title]');
    var packCards = Array.prototype.slice.call(root.querySelectorAll('[data-pack-card]'));
    var shadeOptions = Array.prototype.slice.call(root.querySelectorAll('[data-shade-option]'));

    portalNudge(nudgeEl);

    var state = {
      packQty: 1,
      packPrice: unitPrice,
      packCompare: 0,
      packSave: 0,
      packMrp: unitPrice,
      packCoupon: '',
      packDiscounted: 0,
      packTitle: '',
      selections: [],
      activeSlot: 0
    };

    function readPackFromCard(card) {
      if (!card) return;
      state.packQty = Number(card.dataset.packQty || 1);
      // Payable from Liquid: coupon% → fixed discounted_price → unit×qty
      state.packPrice = Number(card.dataset.packPrice || unitPrice * state.packQty);
      state.packCompare = Number(card.dataset.packCompare || 0);
      state.packSave = Number(card.dataset.packSave || 0);
      state.packMrp = Number(card.dataset.packMrp || state.packCompare || state.packPrice);
      // Applied at checkout only (not used for ATC label math)
      state.packCoupon = (card.dataset.packCoupon || '').trim();
      state.packDiscounted = Number(card.dataset.packDiscounted || 0);
      state.packTitle = card.dataset.packTitle || '';
    }

    var firstPack =
      root.querySelector('[data-pack-card].is-selected') ||
      root.querySelector('[data-pack-card][aria-pressed="true"]') ||
      packCards[0];
    if (firstPack) readPackFromCard(firstPack);

    function selectedCount() {
      return state.selections.filter(Boolean).length;
    }

    function remaining() {
      return Math.max(0, state.packQty - selectedCount());
    }

    function isComplete() {
      return selectedCount() >= state.packQty;
    }

    function progressPct() {
      if (state.packQty <= 0) return 0;
      return Math.min(100, (selectedCount() / state.packQty) * 100);
    }

    function buildNudgeText() {
      if (isComplete()) return nudgeComplete;
      var left = remaining();
      if (selectedCount() === 0) return nudgeEmpty.replace('{n}', String(left));
      return nudgeMore.replace('{n}', String(left));
    }

    function placeNudge() {
      placeUpsellNudge(nudgeEl);
    }

    function shakeNudge() {
      if (!nudgeEl || nudgeEl.hidden) return;
      nudgeEl.classList.remove('is-shaking');
      void nudgeEl.offsetWidth;
      nudgeEl.classList.add('is-shaking');
    }

    function updateNudge(opts) {
      opts = opts || {};
      if (!nudgeEl) return;
      nudgeEl.hidden = false;
      var pct = progressPct();
      if (nudgeFillEl) {
        nudgeFillEl.style.width = pct + '%';
        nudgeFillEl.classList.toggle('is-complete', pct >= 100);
      }
      if (nudgeTextEl) {
        nudgeTextEl.textContent = opts.message || buildNudgeText();
      }
      placeNudge();
      if (opts.shake) shakeNudge();
    }

    if (nudgeEl) {
      nudgeEl.addEventListener('animationend', function () {
        nudgeEl.classList.remove('is-shaking');
      });
    }

    function findAtcButton() {
      return (
        document.querySelector('.pdp-revamp__atc-btn') ||
        document.querySelector('#AddToCart-' + (root.dataset.sectionId || '')) ||
        document.querySelector('.pdp-revamp__atc .product-form__submit')
      );
    }

    function findAtcPriceEl(btn) {
      if (!btn) return null;
      return btn.querySelector('.pdp-revamp__atc-price');
    }

    function updateStickyPrices() {
      var stickyPrice = document.querySelector('.pdp-sticky-atc__price');
      if (stickyPrice) stickyPrice.textContent = moneyFromCents(state.packPrice, currency);

      var stickyCompare = document.querySelector('.pdp-sticky-atc__compare');
      var stickyOff = document.querySelector('.pdp-sticky-atc__off');
      if (state.packSave > 0 && state.packMrp > state.packPrice) {
        if (stickyCompare) {
          stickyCompare.hidden = false;
          stickyCompare.innerHTML = '<s>' + moneyFromCents(state.packMrp, currency) + '</s>';
        }
        if (stickyOff) {
          stickyOff.hidden = false;
          stickyOff.textContent = 'Save ' + moneyFromCents(state.packSave, currency);
        }
      } else {
        if (stickyCompare) {
          stickyCompare.hidden = true;
          stickyCompare.innerHTML = '';
        }
        if (stickyOff) {
          stickyOff.hidden = true;
          stickyOff.textContent = '';
        }
      }
    }

    var isCompleteLook = root.getAttribute('data-atc-cta') === 'add-to-cart';

    function updateAtc() {
      var btn = findAtcButton();
      if (!btn) return;

      var labelEl = btn.querySelector('.pdp-revamp__atc-label');
      var sepEl = btn.querySelector('.pdp-revamp__atc-sep');
      var priceEl = findAtcPriceEl(btn);
      var stickyBtn = document.querySelector('.pdp-sticky-atc__btn');

      if (isCompleteLook) {
        if (labelEl) labelEl.textContent = 'Add to cart';
        if (sepEl) sepEl.hidden = false;
        if (priceEl) {
          priceEl.hidden = false;
          priceEl.textContent = moneyFromCents(state.packPrice, currency);
        }
        if (stickyBtn && !stickyBtn.classList.contains('is-sold-out')) {
          stickyBtn.textContent = 'Add to cart';
        }
      } else {
        // Shade-packs: Buy Now - ₹price
        if (labelEl) labelEl.textContent = 'Buy Now';
        if (sepEl) sepEl.hidden = false;
        if (priceEl) {
          priceEl.hidden = false;
          priceEl.textContent = moneyFromCents(state.packPrice, currency);
        }
        if (stickyBtn && !stickyBtn.classList.contains('is-sold-out')) {
          stickyBtn.textContent = 'Buy Now';
        }
      }

      var saveEl = btn.querySelector('.pdp-revamp__atc-save');
      if (saveEl) {
        saveEl.hidden = true;
        saveEl.textContent = '';
      }

      updateStickyPrices();

      var complete = isComplete();
      btn.classList.toggle('is-pack-disabled', !complete);
      btn.setAttribute('data-pack-disabled', complete ? 'false' : 'true');
      btn.removeAttribute('disabled');
      updateNudge();
    }

    function renderSlots() {
      if (!slotsEl) return;
      var prev = state.selections.slice(0, state.packQty);
      state.selections = [];
      for (var i = 0; i < state.packQty; i++) {
        state.selections[i] = prev[i] || null;
      }

      slotsEl.innerHTML = '';
      for (var s = 0; s < state.packQty; s++) {
        var sel = state.selections[s];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-upsell-pack-builder__slot' + (sel ? ' is-filled' : '');
        btn.dataset.slotIndex = String(s);
        if (sel) {
          var swatchStyle = sel.color
            ? 'background:' + sel.color
            : sel.img
              ? 'background-image:url(' + sel.img + ')'
              : '';
          btn.innerHTML =
            '<span class="pdp-upsell-pack-builder__slot-swatch" style="' +
            swatchStyle +
            '"></span>' +
            '<span class="pdp-upsell-pack-builder__slot-meta">' +
            '<span class="pdp-upsell-pack-builder__slot-name">' +
            (sel.name || '') +
            '</span>' +
            '<span class="pdp-upsell-pack-builder__slot-change">Change shade</span>' +
            '</span>';
        } else {
          btn.innerHTML =
            '<span class="pdp-upsell-pack-builder__slot-plus" aria-hidden="true">+</span>' +
            '<span class="pdp-upsell-pack-builder__slot-label">SHADE ' +
            (s + 1) +
            '</span>';
        }
        btn.addEventListener('click', onSlotClick);
        slotsEl.appendChild(btn);
      }
      updateAtc();
    }

    function openSheet(slotIndex) {
      state.activeSlot = slotIndex;
      if (sheetTitle) {
        sheetTitle.textContent = 'Choose shade for slot ' + (slotIndex + 1);
      }
      shadeOptions.forEach(function (opt) {
        var vid = opt.dataset.variantId;
        var selected = state.selections[slotIndex] && state.selections[slotIndex].variantId === vid;
        opt.classList.toggle('is-selected', !!selected);
        opt.hidden = false;
      });
      root.querySelectorAll('[data-shade-filter]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-shade-filter') === 'all');
      });
      if (sheet) {
        sheet.hidden = false;
        document.documentElement.classList.add('pdp-pack-sheet-open');
      }
    }

    function closeSheet() {
      if (sheet) sheet.hidden = true;
      document.documentElement.classList.remove('pdp-pack-sheet-open');
    }

    function onSlotClick(e) {
      var slotBtn = e.currentTarget;
      var idx = Number(slotBtn.dataset.slotIndex || 0);
      openSheet(idx);
    }

    function selectPack(card) {
      packCards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      readPackFromCard(card);
      renderSlots();
    }

    function trackPackSelect() {
      var analytics = getPackAnalytics(root, state);
      pushUpsellEvent('pack_select', {
        pack_size: analytics.pack_size,
        product_id: analytics.product_id,
        price: analytics.price
      });
    }

    packCards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectPack(card);
        trackPackSelect();
      });
    });

    root.querySelectorAll('[data-shade-sheet-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });

    shadeOptions.forEach(function (opt) {
      opt.addEventListener('click', function () {
        if (opt.disabled || opt.dataset.available === 'false') return;
        var idx = state.activeSlot;
        state.selections[idx] = {
          variantId: opt.dataset.variantId,
          sku: opt.dataset.variantSku,
          productId: opt.dataset.productId,
          name: opt.dataset.shadeName,
          img: opt.dataset.shadeImg || '',
          color: opt.dataset.shadeColor || ''
        };
        closeSheet();
        renderSlots();
      });
    });

    root.querySelectorAll('[data-shade-filter]').forEach(function (filterBtn) {
      filterBtn.addEventListener('click', function () {
        root.querySelectorAll('[data-shade-filter]').forEach(function (b) {
          b.classList.toggle('is-active', b === filterBtn);
        });
        var filter = filterBtn.getAttribute('data-shade-filter');
        shadeOptions.forEach(function (opt) {
          if (filter === 'all') {
            opt.hidden = false;
            return;
          }
          var family = opt.getAttribute('data-shade-family') || '';
          opt.hidden = family !== filter;
        });
      });
    });

    // Helium-shaped cart payload.
    // Bundle_Name = heliumbyob + selected pack payable (₹ on PDP / ATC).
    // _bundle_target_price = same payable; _h_bundle_count = pack qty.
    //
    // TODO: check upsell tags
    // function upsellBundleName(packQty) {
    //   return 'upsell pack of ' + (Number(packQty) || 1);
    // }

    function heliumBundleName(packPriceCents) {
      return 'heliumbyob' + Math.round((Number(packPriceCents) || 0) / 100);
    }

    function buildCartItems() {
      var targetPrice = Math.round(state.packPrice / 100);
      var packQty = state.packQty;
      return state.selections
        .filter(Boolean)
        .map(function (sel) {
          return {
            id: parseInt(sel.variantId, 10),
            quantity: 1,
            properties: {
              _h_bundle_count: packQty,
              _bundle_target_price: targetPrice,
              _is_bundle_item: 'true'
            }
          };
        });
    }

    function setAtcLoading(btn, isLoading) {
      if (!btn) return;
      var spinner = btn.querySelector('.pdp-revamp__atc-spinner, .loading-overlay__spinner');
      if (isLoading) {
        btn.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
      } else {
        btn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      }
    }

    function openGoKwikOrNative() {
      if (window.gokwikSdk && window.merchantInfo) {
        window.gokwikSdk.initCheckout(window.merchantInfo);
        return;
      }
      window.location.href = routesRoot() + 'checkout';
    }

    // /discount/{code} sets a session cookie that survives cart/clear.
    // Packs without a coupon must clear it or a prior pack's code keeps applying.
    function clearDiscountSession(rootPath) {
      try {
        document.cookie = 'discount_code=; path=/; Max-Age=0';
        document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      } catch (e) {
        /* ignore */
      }

      return fetch(rootPath + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).catch(function () {
        /* best-effort clear */
      });
    }

    function applyDiscountCode(rootPath, coupon) {
      return fetch(rootPath + 'discount/' + encodeURIComponent(coupon), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow'
      }).catch(function () {
        /* discount cookie may still be set on redirect responses */
      });
    }

    function openCheckout() {
      var rootPath = routesRoot();
      // Always read from currently selected pack (state.packCoupon), not a prior visit
      var coupon = (state.packCoupon || '').trim();

      // Clear leftover code first, then apply this pack's coupon if any
      // (Pack A coupon → Pack B other coupon / none must not keep A's code)
      return clearDiscountSession(rootPath)
        .then(function () {
          if (!coupon) return;
          return applyDiscountCode(rootPath, coupon);
        })
        .then(function () {
          openGoKwikOrNative();
        });
    }

    function addSelectedToCartAndCheckout() {
      var cartItems = buildCartItems();
      if (!cartItems.length) return Promise.reject(new Error('No shades'));

      var rootPath = routesRoot();

      return fetch(rootPath + 'cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch(rootPath + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: cartItems,
              attributes: {
                // TODO: check upsell tags — Bundle_Name: upsellBundleName(state.packQty)
                Bundle_Name: heliumBundleName(state.packPrice)
              }
            })
          });
        })
        .then(function (res) {
          return res.json();
        })
        .then(function () {
          if (!isCompleteLook) {
            var checkoutAnalytics = getPackAnalytics(root, state);
            pushUpsellEvent('checkout_initiated', {
              pack_name: checkoutAnalytics.pack_name,
              pack_size: checkoutAnalytics.pack_size,
              product_ids: checkoutAnalytics.product_ids,
              price: checkoutAnalytics.price
            });
          }
          return openCheckout();
        });
    }

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('.pdp-revamp__atc-btn, .product-form__submit');
        if (!btn || !document.contains(root)) return;
        if (!root.closest('.pdp-revamp--active') && !document.querySelector('[data-pdp-upsell-pack-builder]')) {
          return;
        }
        if (!document.querySelector('[data-pdp-upsell-pack-builder]')) return;

        e.preventDefault();
        e.stopPropagation();

        if (!isComplete()) {
          setAtcLoading(btn, false);
          updateNudge({ shake: true });
          return;
        }

        if (!isCompleteLook) {
          var buyNowAnalytics = getPackAnalytics(root, state);
          pushUpsellEvent('buy_now_click', {
            ecomm_pagetype: 'cart',
            ecomm_prodid: buyNowAnalytics.ecomm_prodid,
            ecomm_totalvalue: buyNowAnalytics.ecomm_totalvalue,
            value: buyNowAnalytics.value,
            item_id: buyNowAnalytics.item_id,
            item_name: buyNowAnalytics.item_name,
            currency: 'INR',
            pack_name: buyNowAnalytics.pack_name,
            pack_size: buyNowAnalytics.pack_size
          });
        }

        setAtcLoading(btn, true);
        addSelectedToCartAndCheckout()
          .then(function () {
            // GoKwik keeps the page open — clear spinner after sheet can mount
            setTimeout(function () {
              setAtcLoading(btn, false);
            }, 800);
          })
          .catch(function () {
            updateNudge({ message: 'Could not checkout. Please try again.', shake: true });
            setAtcLoading(btn, false);
          });
      },
      true
    );

    // bfcache / back-nav: loading class hid ATC text and never cleared on success path
    window.addEventListener('pageshow', function () {
      var btn = findAtcButton();
      setAtcLoading(btn, false);
      updateAtc();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
    });

    window.addEventListener('resize', placeNudge, { passive: true });
    window.addEventListener('scroll', placeNudge, { passive: true });

    renderSlots();
  }

  function openAquaCartDrawer(trigger) {
    var drawer =
      document.querySelector('hdt-cart-drawer#CartDrawer') ||
      document.querySelector('hdt-cart-drawer') ||
      document.querySelector('cart-drawer');

    if (drawer && typeof drawer.openDialog === 'function') {
      drawer.openDialog();
      return true;
    }
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger);
      return true;
    }

    var cartBtn =
      document.querySelector('#cart-icon-bubble[aria-controls="CartDrawer"]') ||
      document.querySelector('[aria-controls="CartDrawer"]');
    if (cartBtn) {
      cartBtn.click();
      return true;
    }
    return false;
  }

  function initCompleteLookCartOpen(root) {
    if (!root || root.dataset.cartOpenReady === 'true') return;
    root.dataset.cartOpenReady = 'true';

    var pendingOpen = false;
    var clearPendingTimer = null;

    function armPending() {
      pendingOpen = true;
      if (clearPendingTimer) clearTimeout(clearPendingTimer);
      // Drop the flag if ATC errors / never fires cart events
      clearPendingTimer = setTimeout(function () {
        pendingOpen = false;
        clearPendingTimer = null;
      }, 4000);
    }

    function isCompleteLookAtcButton(btn) {
      if (!btn || !document.contains(root)) return false;
      if (root.contains(btn)) return true;

      // Shade overflow modal can be portaled to <body>
      var modal = btn.closest('hdt-modal.card-product-modal, hdt-modal');
      if (!modal || !modal.id) return false;
      return !!root.querySelector('[aria-controls="' + modal.id + '"]');
    }

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest(
          'button[name="add"], .hdt-pr13-card__atc, .card-product-modal-form button[type="submit"]'
        );
        if (!btn || btn.tagName === 'A' || btn.classList.contains('is-disabled')) return;
        if (!isCompleteLookAtcButton(btn)) return;
        armPending();
      },
      true
    );

    function maybeOpenDrawer() {
      if (!pendingOpen) return;
      pendingOpen = false;
      if (clearPendingTimer) {
        clearTimeout(clearPendingTimer);
        clearPendingTimer = null;
      }
      // Let theme toast / section refresh settle, then open side cart
      setTimeout(function () {
        openAquaCartDrawer();
      }, 80);
    }

    document.addEventListener('variant:add', maybeOpenDrawer);
    document.addEventListener('cart:change', function (event) {
      var base = event && event.detail && event.detail.baseEvent;
      if (base && base !== 'variant:add') return;
      maybeOpenDrawer();
    });
  }

  function boot() {
    document.querySelectorAll('[data-pdp-upsell-pack-builder]').forEach(initPackBuilder);
    document.querySelectorAll('[data-pdp-upsell-complete-look]').forEach(initCompleteLookCartOpen);
  }

  var analyticsApi = {
    centsToRupees: centsToRupees,
    packNameFromSize: packNameFromSize,
    getPackAnalytics: getPackAnalytics,
    pushUpsellEvent: pushUpsellEvent,
    boot: boot
  };
  if (typeof window !== 'undefined') {
    window.PdpUpsellAnalytics = analyticsApi;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = analyticsApi;
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  }
})();
